import PropTypes from 'prop-types';
import { Fragment, PureComponent } from 'react';
import { connect } from 'react-redux';
import { appointmentDraftActions, journeyStateSelectors } from '~/api';
import {
  apiCallFinished,
  errorMessagesActions,
  PartnersIntro,
  ScreenNav,
  SelectablePartnerList,
  withProgressBar,
  withRequiredPrecondition,
  withRestorableDraft,
} from '~/components';
import { isNotEmpty } from '~/utils';
import { loadPartners } from './partners.actions';
import styles from './Partners.scss';

export class Partners extends PureComponent {
  state = {
    isAjaxCompleted: false,
  };

  componentDidMount() {
    const {
      handleLoadedPartners,

      dispatchLoadPartners,
      dispatchApiCallFinished,
    } = this.props;

    dispatchApiCallFinished(false);
    dispatchLoadPartners(handleLoadedPartners).then(() => {
      this.setState({ isAjaxCompleted: true });
      dispatchApiCallFinished(true);
    });
    window.scrollTo(0, 0);
  }

  selectPartner = (partner) => {
    const { dispatchApiCallFinished, dispatchSelectPartner, dispatchSavePartner, history } =
      this.props;

    dispatchApiCallFinished(false);
    dispatchSelectPartner(partner);
    dispatchSavePartner().then(() => {
      history.pushWithToken('/select-date');
    });
  };

  render() {
    const {
      partners,
      selectedShop: { name: selectedShopName },
      prevPath,
      onPrevClick,
      config: {
        partnerTitle,
        partnerPrefix,
        defaultPartnerText,
        PartnersIntro: partnersIntroConfig,
      },
    } = this.props;

    const { isAjaxCompleted } = this.state;

    return (
      <Fragment>
        <section
          data-testid="Partners"
          data-test-ajax={isAjaxCompleted}
          className={styles.PartnersContainer}
        >
          {selectedShopName ? (
            <PartnersIntro
              shopName={selectedShopName}
              partnerTitle={partnerTitle}
              partnerName={partners.length === 1 ? partners[0].name : undefined}
              {...partnersIntroConfig}
            />
          ) : null}
          {partners.length > 0 && (
            <div className={styles.Divider}>
              <SelectablePartnerList
                handleSelect
                partners={partners}
                selectPartner={this.selectPartner}
                partnerTitle={partnerTitle}
                partnerPrefix={partnerPrefix}
                defaultPartnerText={defaultPartnerText}
                {...partnersIntroConfig}
              />
            </div>
          )}
        </section>
        <ScreenNav prevPath={prevPath} onPrevClick={onPrevClick} hideNextButton />
      </Fragment>
    );
  }
}

export const mapStateToProps = (state) => {
  const {
    partners: { partners },
    appointment: {
      draft: { shop },
    },
    services: { config },
  } = state;
  const prevPathConfigFromToken = journeyStateSelectors.selectPathConfigForPage(state);
  return {
    partners,
    selectedShop: shop,
    config,
    prevPath: isNotEmpty(prevPathConfigFromToken) ? null : config.partnersPrevPath,
    onPrevClick: isNotEmpty(prevPathConfigFromToken)
      ? () => {
          window.location.href = prevPathConfigFromToken.prevPath;
        }
      : null,
  };
};

const mapDispatchToProps = {
  dispatchLoadPartners: loadPartners,
  dispatchSelectPartner: appointmentDraftActions.setPartner,
  dispatchSavePartner: appointmentDraftActions.saveAppointmentDraft,
  dispatchResetErrorMessagesWith: errorMessagesActions.resetErrorMessagesWith,
  dispatchClearErrorMessages: errorMessagesActions.clearErrorMessages,
  dispatchApiCallFinished: apiCallFinished,
};

export const ConnectedPartners = withRestorableDraft(
  withRequiredPrecondition(connect(mapStateToProps, mapDispatchToProps)(withProgressBar(Partners))),
);

Partners.propTypes = {
  history: PropTypes.shape({}).isRequired,
  partners: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  selectedShop: PropTypes.shape({}).isRequired,
  config: PropTypes.shape({
    partnerTitle: PropTypes.string.isRequired,
    partnerPrefix: PropTypes.string.isRequired,
    PartnersIntro: PropTypes.shape({}).isRequired,
  }).isRequired,
  prevPath: PropTypes.string,
  onPrevClick: PropTypes.func,

  handleLoadedPartners: PropTypes.func,

  dispatchLoadPartners: PropTypes.func.isRequired,
  dispatchSelectPartner: PropTypes.func.isRequired,
  dispatchSavePartner: PropTypes.func.isRequired,
  dispatchResetErrorMessagesWith: PropTypes.func.isRequired,
  dispatchApiCallFinished: PropTypes.func.isRequired,
  dispatchClearErrorMessages: PropTypes.func.isRequired,
};

Partners.defaultProps = {
  prevPath: null,
  onPrevClick: null,
  handleLoadedPartners: undefined,
};
